import React, { useState, useEffect, useCallback } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import { Box, CircularProgress } from '@material-ui/core';
import CardHolder from 'app/components/CardHolder';
import Modal from './Modal';

import CustomTable from 'app/components/CustomTable';
import alertsEndpoint from 'app/api/services/alertsEndpoint';
import moment from 'moment';

import styles from './styles';
import Filter from '../Filter';
const useStyles = makeStyles(styles);

function Alerts(props) {
    const classes = useStyles();
    const { intl } = props;
    const [open, setOpen] = useState(false);
    const [openFilter, setOpenFilter] = useState(false);
    const [selectedAlert, setSelectedAlert] = useState({});
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [filters, setFilters] = useState({});

    const openModal = (item, v) => {
        const position = v.tableData?.id;
        setSelectedAlert(data[position]);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const parseDataRow = useCallback(
        (values) => {
            const dataRow = values.map((item) => {
                let description = item.deAlerta?.substring(0, 30);
                if (item.deAlerta?.length > 30) description = description + '...';
                const temp = (
                    <div className={classes.listItem}>
                        <div className={classes.date}>{moment.utc(item.dtCadastro).format('DD/MM/YYYY')}</div>
                        {item.cdSolicitacao && (
                            <div className={classes.request}>{`${intl.formatMessage({
                                id: 'LABELS.SERVICES.REQUESTS',
                            })} ${item.solicitacao?.nuSolicitacaoFmt}`}</div>
                        )}
                        <Box className={classes.boxDescription} color="secondary.main">
                            <div className={classes.description}>{description}</div>
                        </Box>
                    </div>
                );
                return { data: temp, originalData: item };
            });
            setData(dataRow);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    const findAlerts = useCallback(
        async (filtersParam) => {
            setLoading(true);
            const aditionalFilters = {};
            if (filtersParam) {
                if (filtersParam.nuSolicitacao) aditionalFilters.txtBusca = filtersParam.nuSolicitacao;
                if (filtersParam.dtPeriodoInicial) aditionalFilters.dtPeriodoInicial = filtersParam.dtPeriodoInicial;
                if (filtersParam.dtPeriodoFinal) aditionalFilters.dtPeriodoFinal = filtersParam.dtPeriodoFinal;
                if (filtersParam.cdServico) aditionalFilters.servicos = [{ cdServico: Number(filtersParam.cdServico) }];
            }

            const search = {
                page: 0,
                size: 5,
                request: { ...aditionalFilters },
            };

            try {
                const response = await alertsEndpoint.findAlerts(search);
                if (response.status === 200 && response.data?.content && response.data?.content.length > 0) {
                    parseDataRow(response.data.content);
                }
            } catch (error) {}
            setLoading(false);
        },
        [parseDataRow],
    );

    useEffect(() => {
        findAlerts();
    }, [findAlerts]);

    const columns = [{ title: 'Dados', field: 'data' }];

    const handleSendFilter = (cleaning) => {
        if (cleaning) findAlerts();
        if (!cleaning && Object.keys(filters).length > 0) {
            findAlerts(filters);
        }
        setOpenFilter(false);
    };

    return (
        <>
            <Modal open={open} onClose={handleClose} alert={selectedAlert} />
            <Filter
                open={openFilter}
                filters={filters}
                setFilters={setFilters}
                onClose={() => setOpenFilter(false)}
                sendFilter={handleSendFilter}
                hasNuSolicitacao={true}
                hasTpServico={true}
                hasDtPeriodoInicial={true}
                hasDtPeriodoFinal={true}
            />
            <CardHolder
                title={intl.formatMessage({ id: 'LABELS.ALERTS.TITLE' })}
                handleFilter={() => setOpenFilter(true)}>
                <div className={classes.internalContainer}>
                    {loading && (
                        <div className={classes.centerProgress}>
                            <CircularProgress size={20} />
                        </div>
                    )}
                    {!loading && !!data && data.length > 0 && (
                        <CustomTable columns={columns} data={data} onclick={openModal} />
                    )}
                </div>
            </CardHolder>
        </>
    );
}

export default injectIntl(Alerts);
